import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id DF225E4A-DED0-43C3-83B1-4867ABA9D45B
 * name numeric-1
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-1.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric1Icon = createSvgIcon(<><path d="M10,7V9H12V17H14V7H10Z" /></>, 'Numeric1Icon');
export default Numeric1Icon